<template>
  <div v-if="can(action, globalHashid) || can(action, subject)">
    <slot />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AbilityWrapper",
  props: {
    globalHashid: {
      type: String,
      default: undefined,
    },
    subject: {
      type: String,
      default: undefined,
    },
    action: {
      required: true,
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      can: "currentUser/can",
    }),
  },
  created() {
    this.checkAbility({
      action: this.action,
      globalHashid: this.globalHashid,
      subject: this.subject,
    });
  },
  methods: {
    ...mapActions({
      checkAbility: "currentUser/checkAbility",
    }),
  },
};
</script>
